(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define(["react"], factory);
	else if(typeof exports === 'object')
		exports["SemiIllustrations"] = factory(require("react"));
	else
		root["SemiIllustrations"] = factory(root["React"]);
})(self, (__WEBPACK_EXTERNAL_MODULE_neV8__) => {
return 